import Contents from '../module/scroll/contents';

export default class FeedingAmountManager {
    constructor() {

        this.contents = new Contents()

        this.$container
        this.$trigger
        this.$line
        this.$spTrigger
        this.$form

        this.query = (location.search) ? location.search : false
        this.currentCat = this.query === '?cat' ? true : false

        this.status = {
            current : this.currentCat ? 1 : 0,
            prevCurrent : this.currentCat ? 0 : 1,
            flag : false,
        }

        this.isSp = window.innerWidth<=750

        this.$root = document.getElementById('l-root')
        this.$body = document.getElementById('l-scroll-body')

    }

    init(){

        // タブ切り替え
        this.$container = document.getElementById('p-feedingAmount-contents')
        this.$trigger = this.$container.querySelectorAll('[data-tab-trigger]')
        this.$line = this.$container.querySelectorAll('[data-tab-line]')
        this.$spTrigger = this.$container.querySelector('[data-select-trigger]')
        this.$options = this.$spTrigger.querySelectorAll('option')
        this.$triggerText = this.$container.querySelector('.content__select-text')
        this.$form = this.$container.querySelectorAll('[data-form]')

        TweenMax.set(this.$line,{x:-100+'%'})
        TweenMax.set(this.$line[this.status.current], { x: 0 + '%' })
        this.$trigger[this.status.prevCurrent].classList.remove('-current')
        this.$trigger[this.status.current].classList.add('-current')
        this.$options[this.status.prevCurrent].selected = false
        this.$options[this.status.current].selected = true
        this.$triggerText.innerHTML = this.$options[this.status.current].text
        this.change()

        for (let i = 0; i < this.$form.length; i++) {
            new FeedingAmountForm(this.$form[i])

            if (i !== this.status.current) {
                TweenMax.set(this.$form[i],{opacity:0})
            }
        }

        for(let i in this.$trigger){
            if(this.$trigger[i].nodeType!==1) break
            this.$trigger[i].addEventListener('click',(e)=>{
                let _select = e.target.getAttribute('data-target')

                if(this.status.flag||this.status.current==_select) return

                this.status.flag = true
                this.status.prevCurrent = this.status.current
                this.status.current = _select

                this.$trigger[this.status.prevCurrent].classList.remove('-current')
                this.$trigger[this.status.current].classList.add('-current')
                this.change()
            })
        }

        this.$spTrigger.addEventListener('change',(e)=>{
            let _select = e.target.value
            let index = e.target.selectedIndex

            this.$triggerText.innerHTML = e.target.options[index].text;

            if(this.status.flag||this.status.current==_select) return

            this.status.flag = true
            this.status.prevCurrent = this.status.current
            this.status.current = _select

            this.change()
        })

    }

    change() {

        if (this.isSp) {
            TweenMax.to(this.$form[this.status.prevCurrent],0.4,{
                opacity:0,
                onComplete:()=>{
                    this.status.flag = false
                    this.$form[this.status.prevCurrent].classList.remove('-current')
                    this.$form[this.status.current].classList.add('-current')
                    this.$options[this.status.prevCurrent].selected = false
                    this.$options[this.status.current].selected = true
                    TweenMax.to(this.$form[this.status.current],0.8,{
                        opacity:1,
                    })
                }
            })
        } else {
            TweenMax.to(this.$line[this.status.prevCurrent],0.4,{
                x:this.status.prevCurrent<=this.status.current?100+'%':-100+'%'
            })

            TweenMax.to(this.$form[this.status.prevCurrent],0.4,{
                opacity:0,
                onComplete:()=>{
                    this.status.flag = false
                    this.$form[this.status.prevCurrent].classList.remove('-current')
                    this.$form[this.status.current].classList.add('-current')
                    TweenMax.to(this.$line[this.status.current],0.4,{x:0+'%'})
                    TweenMax.to(this.$form[this.status.current],0.8,{
                        opacity:1,
                    })
                    this.resize()
                }
            })
        }

    }

    resize() {

        TweenMax.set(this.$root,
            {
                'height': this.$body.clientHeight,
            }
        )
        this.contents.resize();

    }
}

export class FeedingAmountForm {
    constructor(form) {

        this.contents = new Contents()

        this.$form = form
        this.$selectArea = this.$form.querySelectorAll('[data-select-area]')
        this.$clearButton = this.$form.querySelector('[data-clear-button]')
        this.$calculateButton = this.$form.querySelector('[data-calculate-button]')
        this.$errorArea = this.$form.querySelector('[data-error-area]')
        this.$errorTexts = this.$form.querySelectorAll('[data-error-item]')
        this.$resultArea = this.$form.querySelector('[data-result-area]')
        this.$result = this.$resultArea.querySelector('[data-result]')
        this.$contraceptions = this.$form.querySelectorAll('.radio-button')
        this.$food = this.$form.querySelector('[data-food]')
        this.$age = this.$form.querySelector('[data-age]')

        this.status = {
            type: this.$form.id === 'form-dog' ? 'dog' : 'cat',
            current: [],
            error: false,
        }

        this.$root = document.getElementById('l-root')
        this.$body = document.getElementById('l-scroll-body')
        this.$container = document.getElementById('p-feedingAmount__inner')

        this.isSp = window.innerWidth <= 750

        // 初期表示
        TweenMax.set(this.$selectArea, { opacity: 0.5 })
        TweenMax.set(this.$resultArea, { opacity: 0 })

        for (let i = 0; i < this.$selectArea.length; i++) {
            this.status.current.push(false)

            // 変更があったら活性化
            this.$selectArea[i].addEventListener('change', () => {
                if (this.status.current[i]) return
                TweenMax.set(this.$selectArea[i], { opacity: 1 })
                this.status.current[i] = true
            })
        }

        // クリアボタン
        this.$clearButton.addEventListener('click', () => {
            TweenMax.set(this.$selectArea, { opacity: 0.5 })
            this.hideResultArea()
            this.status.current = []
            for (let i = 0; i < this.$selectArea.length; i++) {
                this.status.current.push(false)
            }
            this.resetError()
            this.Initialization()
            this.resize()
            this.scroll(this.$body.clientHeight - this.$container.clientHeight)
        })

        // 計算ボタン
        this.$calculateButton.addEventListener('click', () => {
            this.check()
        })

        // キャットフード：年齢によって避妊去勢の項目を表示非表示切り替える
        this.currentContraception = true
        this.contraception = this.$form.querySelector('[data-contraception]')
        this.layout = this.isSp ? 'block' : 'flex'
        if (this.status.type === 'cat') {
            this.switchContraceptionDisplay()
            // 避妊・去勢した愛猫用を選択時、自動でチェックを入れる
            this.$food.addEventListener('change', () => {
                if (this.$food.value === '1') {
                    this.$contraceptions[1].checked = true
                }
            })
        }

        // フードを選んだ時に年齢の選択肢を変化させる
        this.$food.addEventListener('change', () => {
            TweenMax.set(this.$age, { opacity: 0.5 })
            this.status.current[1] = false
            this.updateAgeArea(this.status.type)
        })

    }

    switchContraceptionDisplay() {

        this.$form.age.addEventListener('change', () => {
            if (this.$form.age.value === '0' || this.$form.age.value === '1') {
                if (this.currentContraception) {
                    TweenMax.to(this.contraception, 0.4,
                        {
                            opacity: 0,
                            display: 'none',
                            onComplete: () => {
                                this.currentContraception = false
                                this.resize()
                            }
                        }
                    )
                }
            } else {
                if (!this.currentContraception) {
                    TweenMax.set(this.contraception, { display: this.layout })
                    TweenMax.to(this.contraception, 0.4,
                        {
                            opacity: 1,
                            onComplete: () => {
                                this.currentContraception = true
                                this.resize()
                            }
                        }
                    )
                }
            }
        })

    }

    resetError() {
        this.status.error = false
        this.$errorArea.classList.remove('-current')
        for (let i = 0; i < this.$errorTexts.length; i++) {
            this.$errorTexts[i].classList.remove('-current')
        }
    }

    Initialization() {
        this.$contraception = ''
        this.updateAgeArea(this.status.type)
        if (this.status.type === 'cat') {
            TweenMax.set(this.contraception, { display: this.layout, opacity: 1 })
            this.resize()
        }
    }

    hideResultArea() {
        this.$resultArea.classList.remove('-current')
        TweenMax.to(this.$resultArea, 0.4, { opacity: 0 })
    }

    updateAgeArea(type) {
        let options = [...this.$age.querySelectorAll('option')]
        options.forEach((el, i) => {
            if (i === 0) return
            this.$age.removeChild(el)
        })

        let ageList = ['離乳〜3ヶ月','4〜6ヶ月','7〜12ヶ月','1歳','2歳','3歳','4歳','5歳','6歳','7歳','8歳','9歳','10歳','11歳以上']
        let start = 0
        let end = 13

        if (type === 'dog') {
            switch (this.$food.value) {
                case '0': // アレルゲンケア＆pHコントロール・1歳から
                case '2': // アレルゲンケア＆pHコントロール・ダイエット用
                case '4': // スタンダードタイプ・1歳から
                case '6': // スタンダードタイプ・1歳から 体重管理用
                case '7': // スタンダードタイプ 腎臓・心臓の健康維持
                case '9': // 超小粒タイプ・1歳から
                case '11': // 超小粒タイプ・1歳から 体重管理用
                case '12': // 超小粒タイプ 腎臓・心臓の健康維持
                    start = 3, end = 13
                    break
                case '1': // アレルゲンケア＆pHコントロール・11歳から
                    start = 13, end = 13
                    break
                case '3': // スタンダードタイプ・1歳まで　子いぬ用
                case '8': // 超小粒タイプ・1歳まで　子いぬ用
                    start = 0, end = 2
                    break
                case '5': // スタンダードタイプ・7歳から
                case '10': // 超小粒タイプ・7歳から
                    start = 9, end = 13
                    break
                default:
                    start = 0, end = 13
                    break
            }
        } else {
            switch (this.$food.value) {
                case '0': // pHコントロール＆エクストラケア・1歳まで 子ねこ用
                    start = 0, end = 2
                    break
                case '1': // pHコントロール＆エクストラケア・避妊・去勢した愛猫用
                    start = 2, end = 13
                    break
                case '2': // pHコントロール＆エクストラケア・11歳から
                    start = 13, end = 13
                    break
                case '3': // 腎臓の健康維持
                    start = 3, end = 13
                    break
                default:
                    start = 0, end = 13
                    break
            }
        }

        for (let i = start; i < end+1; i++) {
            let option = document.createElement('option')
            option.value = i
            option.textContent = ageList[i]
            this.$age.appendChild(option)
        }

    }

    check() {

        this.resetError()

        // 入力チェック
        if (this.$form.food.value === '') {
            this.status.error = true
            this.$errorTexts[0].classList.add('-current')
        }

        let isNumber = this.$form.bodyweight.value.match(/^[0-9０-９]+$/)
        let isDecimalPoint = this.$form.bodyweight.value.match(/^[0-9０-９]+\.[0-9０-９]+$/)
        if (this.$form.bodyweight.value === '' || this.$form.bodyweight.value < 0 || (!isNumber && !isDecimalPoint)) {
            if (!this.status.error) this.status.error = true
            this.$errorTexts[1].classList.add('-current')
        }

        if (this.$form.age.value === '') {
            if (!this.status.error) this.status.error = true
            this.$errorTexts[2].classList.add('-current')
        }

        this.$contraception = ''
        for (let i = 0; i < this.$contraceptions.length; i++) {
            if (this.$contraceptions[i].checked) {
                this.$contraception = this.$contraceptions[i].value
            }
        }

        if (this.$contraception === '' && this.currentContraception) {
            if(!this.status.error) this.status.error = true
            this.$errorTexts[3].classList.add('-current')
        }

        if(this.$form.bodyshape.value === '') {
            if(!this.status.error) this.status.error = true
            this.$errorTexts[4].classList.add('-current')
        }

        if(this.status.error) {
            this.$errorArea.classList.add('-current')
            this.hideResultArea()
            this.resize()
            this.scroll(this.$body.clientHeight - this.$container.clientHeight)

        } else {
            this.caluculation()
            this.resize()
            this.scroll(this.$body.clientHeight)
        }

    }

    conversion(str) {
        return str.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    }

    caluculation() {

        let bodyweight = Math.floor(Number(this.conversion(this.$form.bodyweight.value)) * 10) / 10 // 小数点第二以降は切り捨て
        let age = 1
        let contraception = 1
        let bodyshape = 1
        let ME = 1

        if (this.status.type === 'dog') {

            switch (this.$form.food.value) {
                case '0': ME = 3.5 // アレルゲンケア＆pHコントロール・1歳から
                    break
                case '1': ME = 3.55 // アレルゲンケア＆pHコントロール・11歳から
                    break
                case '2': ME = 3.15 // アレルゲンケア＆pHコントロール・ダイエット用
                    break
                case '3': ME = 3.65 // スタンダードタイプ・1歳まで 子いぬ用
                    break
                case '4': ME = 3.65 // スタンダードタイプ・1歳から
                    break
                case '5': ME = 3.4 // スタンダードタイプ・7歳から
                    break
                case '6': ME = 3.2 // スタンダードタイプ・1歳から 体重管理用
                    break
                case '7': ME = 3.6 // スタンダードタイプ 腎臓・心臓の健康維持
                    break
                case '8': ME = 4.1 // 超小粒タイプ・1歳まで 子いぬ用
                    break
                case '9': ME = 3.8 // 超小粒タイプ・1歳から
                    break
                case '10': ME = 3.7 // 超小粒タイプ・7歳から
                    break
                case '11': ME = 3.45 // 超小粒タイプ・1歳から 体重管理用
                    break
                case '12': ME = 3.95 // 超小粒タイプ 腎臓・心臓の健康維持
                    break
                default: ME = 1
                    break
            }

            switch (this.$form.age.value) {
                case '0': age = 3.3 // 離乳〜3ヶ月
                    break
                case '1': age = 2.8 // 4〜6ヶ月
                    break
                case '2': age = 2.3 // 7〜12ヶ月
                    break
                case '3':
                case '4':
                case '5':
                    age = 1.85  // 1〜3歳
                    break
                case '6':
                case '7':
                case '8':
                    age = 1.6  // 4〜6歳
                    break
                case '9':
                case '10':
                case '11':
                case '12':
                    age = 1.4  // 7〜10歳
                    break
                case '13': age = 1.5  // 11歳以上
                    break
                default: age = 1
                    break
            }

            contraception = this.$form.contraception.value === '1' ? 0.9 : 1
            bodyshape = this.$form.bodyshape.value === '1' ? 0.8 : 1

        } else {

            switch (this.$form.food.value) {
                case '0': // pHコントロール＆エクストラケア・1歳まで 子ねこ用
                case '2': // pHコントロール＆エクストラケア・11歳から
                    ME = 3.9
                    break
                case '1': // pHコントロール＆エクストラケア・避妊・去勢した愛猫用
                    ME = 3.5
                    break
                case '3': // 腎臓の健康維持
                    ME = 3.85
                    break
                default:
                    ME = 1
                    break
            }

            switch (this.$form.age.value) {
                case '0': age = 3 // 離乳〜3ヶ月
                    break
                case '1': age = 2.5 // 4〜6ヶ月
                    break
                case '2': age = 2 // 7〜12ヶ月
                    break
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                    age = 1.4 // 1〜6歳
                    break
                case '9':
                case '10':
                case '11':
                case '12':
                    age = 1.2 // 7〜10歳
                    break
                case '13': age = 1 // 11歳以上
                    break
                default: age = 1
                    break
            }

            if (this.$form.contraception.value === '1') {
                switch (this.$form.age.value) {
                    case '0':
                    case '1':
                    case '13':
                        contraception = 1  // 6ヶ月未満または11歳以上
                        break
                    case '2': contraception = 0.75 // 7〜12ヶ月
                        break
                    case '3':
                    case '4':
                    case '5':
                    case '6':
                    case '7':
                    case '8':
                        contraception = 0.86 // 1〜6歳
                        break
                    case '9':
                    case '10':
                    case '11':
                    case '12':
                        contraception = 0.92 // 7〜10歳
                        break
                    default: contraception = 1
                        break
                }
            } else {
                contraception = 1
            }

            bodyshape = this.$form.bodyshape.value === '1' ? 0.8 : 1

        }

        let PER = Math.pow(bodyweight, 0.75) * 70
        let DER = PER * age * contraception * bodyshape
        let number = DER / ME
        let result = Math.round(Math.floor(number * 10) / 10) // 小数点1までに整形して四捨五入

        this.$resultArea.classList.add('-current')
        this.$result.innerHTML = Math.floor(result * 10) / 10
        TweenMax.to(this.$resultArea, 0.4, { opacity: 1 })

    }

    scroll(inc) {

        TweenLite.to(window, 0.05, { duration: 0.3, scrollTo: inc })

    }

    resize() {

        if(this.isSp) return
        TweenMax.set(this.$root, { 'height': this.$body.clientHeight })
        this.contents.resize();

    }

}